import { agents, agentActionType,SAVE_AGENTS } from './types';

export function SaveAgents(agents: agents): agentActionType {
  return {
    type: SAVE_AGENTS,
    payload: agents,
  };
}
